<ng-container *ngIf="value">
    <shared-route-part-cmr-digitaldocument-component [routePartCMRId]="value.routePartCMRId">
    </shared-route-part-cmr-digitaldocument-component>
    <shared-documentaryreview-item-documents-component class="block-data" [doLoadDocuments]="false"
        [parentObject]="parentObject" [documents]="documents" (dataRefresh)="onDataRefresh($event)"
        [resourceTitle]="'DOCUMENTARYREVIEW.IMPORT.TITLE'"></shared-documentaryreview-item-documents-component>
    <div class="dummy">
        dummy
    </div>
</ng-container>